// removed by extract-text-webpack-plugin
module.exports = {"newProductFormWrap":"qempo_NewProductForm_newProductFormWrap-9QuJbCb","headerWrap":"qempo_NewProductForm_headerWrap-388bWyo","title":"qempo_NewProductForm_title-2pB-FYv","contentWrap":"qempo_NewProductForm_contentWrap-376UI33","leftWrap":"qempo_NewProductForm_leftWrap-1JSFMkg","rightWrap":"qempo_NewProductForm_rightWrap-14fVWgc","sticky":"qempo_NewProductForm_sticky-162m95L"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/new-order/ProductStep/components/NewProductForm/NewProductForm.scss
// module id = 1628
// module chunks = 0